/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/

import { Box, Paper, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { withAppData } from '../../app/AppProvider';
import { runQuery, useQuery } from '../../app/GraphQLWSClient';
import { ConnectionIcon } from './ConnectionIcon';
import SettingsPaper from '../../utils/SettingsPaper';
import CONNECTION_MODULES_QUERY from './connection-modules.gql';
import CREATE_CONNECTION_MUTATION from './create-connection.gql';

export const NewConnection = withAppData(({ machine }) => ({ appId: machine.id }))(
	({ appId, onClose, onNewConnection }) => {
		const onAddConnection = async (type: string) => {
			try {
				const result = await runQuery(CREATE_CONNECTION_MUTATION, { appId, type });
				if (result.createConnection.success) {
					onNewConnection(result.createConnection.id);
				} else {
					console.error(result.createConnection.message);
					onClose();
				}
			} catch (error) {
				console.error(error);
				onClose();
			}
		};
		const { status, result } = useQuery(CONNECTION_MODULES_QUERY);
		useEffect(() => {
			if (status === 'error') {
				console.error(result);
			}
		}, [status]);

		return (
			<SettingsPaper
				open
				helpContext="connectionsettings"
				close={() => onClose()}
				// @ts-ignore
				style={{ width: '600px' }}
				title={<FormattedMessage id="ConnectionNew.Title" defaultMessage="Create Connection" />}
			>
				<Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
					{status === 'done'
						? result.connectionModules.map((cm) => (
								<Paper key={cm.id} onClick={() => onAddConnection(cm.id)} style={{ cursor: 'pointer' }}>
									<Box p={2} sx={{ display: 'flex', flexDirection: 'column' }}>
										<Box sx={{ display: 'grid', gridGap: '8px', gridTemplateColumns: '24px 1fr' }}>
											<ConnectionIcon src={cm.logo} />
											<Typography variant="h6">{cm.name}</Typography>
										</Box>
										<Typography variant="subtitle1">{cm.description}</Typography>
									</Box>
								</Paper>
						  ))
						: 'LOADING'}
				</Box>
			</SettingsPaper>
		);
	}
);
